import vue from 'vue';
import vueRouter from 'vue-router';
import VueGtag from 'vue-gtag';
import { bootstrap } from 'vue-gtag';
import vue2Filters from 'vue2-filters';
import ravenJs from 'raven-js';
import Router from './Router';
import { mapState } from 'vuex';
import store from './store';
import axios from 'axios';
import { get as getCookie } from 'es-cookie';
// tslint:disable-next-line
import RavenVue from 'raven-js/plugins/vue';
axios.interceptors.request.use(function (request) {
    request.headers['Content-Type'] = 'application/json';
    if (localStorage.getItem('at_access_token')
        && request.url
        && request.url.indexOf('adventure.travel/api/') > -1
        && !request.headers['Authorization']) {
        // If request is to Adventure.Travel API, use at_access_token
        request.headers['Authorization'] = 'Bearer ' + localStorage.getItem('at_access_token');
    }
    else if (getCookie('atta_token')
        && !request.headers['Authorization']) {
        // Use access_token
        request.headers['Authorization'] = 'Bearer ' + getCookie('atta_token');
    }
    return request;
});
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response && error.response.status === 403) {
        app.$router.push('/community-member');
    }
    if (error.response && error.response.status === 406) {
        window.location.href = appConfig.myAccountUrl + "/confirm-email";
        return;
        // app.$router.push('/confirm-email');
        /*if (typeof error.response.data === 'object'
          && error.response.data !== null
          && error.response.data.redirect
          && error.response.data.redirect !== null
        ) {
          const redirect = error.response.data.redirect;
  
          if (redirect === 'pending') {
            app.$router.push('/pending');
          } else if (redirect === 'deactivated') {
            app.$router.push('/deactivated');
          } else if (redirect === 'email confirmation') {
            app.$router.push('/confirm-email');
          } else if (redirect === 'access denied') {
            app.$router.push('/access-denied');
          }
        }*/
    }
    if (error.response && error.response.status === 404) {
        app.$router.push('/404');
    }
    return Promise.reject(error);
});
ravenJs
    .config('https://66b17b4432c84e6fbc5c549d80d1849f@sentry.io/150414')
    .addPlugin(RavenVue, vue)
    .install();
vue.use(vueRouter);
vue.use(vue2Filters);
var shouldDisableGA = true;
// Google Analytics
var consentValue = getCookie('CookieConsent');
if (consentValue
    && (consentValue === '-1'
        || (consentValue.includes('statistics:true')
            || consentValue.includes('statistics: true')))) {
    shouldDisableGA = false;
}
vue.use(VueGtag, {
    config: {
        id: 'G-1DLMHK2XP7',
    },
    disableScriptLoad: shouldDisableGA,
}, Router);
// Add "includes" method
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        var innerStart = start;
        if (typeof innerStart !== 'number') {
            innerStart = 0;
        }
        if (innerStart + search.length > this.length) {
            return false;
        }
        return this.indexOf(search, innerStart) !== -1;
    };
}
var app = new vue({
    store: store,
    router: Router,
    el: '#app',
    // tslint:disable-next-line
    mounted: function () {
        if (getCookie('atta_token')) {
            this.$store.dispatch('LOAD_CONTEXT');
            this.$store.dispatch('GET_USER');
            // this.$store.dispatch('GET_CART');
            // Create customer if one doesn't exist
            /*let _url = appConfig.serverUrl + '/api/v1/payment/customer';
            axios.post(_url, { access_token: localStorage.getItem('access_token') })
                .catch((err) => {
                    console.log(err);
                });*/
            // if (window.location.href.indexOf('/adventure-travel/') > -1) {
            // } else {
            //   window.location.replace('https://hub.adventuretravel.biz');
            // }
        }
    },
    // tslint:disable-next-line
    updated: function () {
        var consentValue = getCookie('CookieConsent');
        if (consentValue
            && (consentValue.includes('statistics:true')
                || consentValue.includes('statistics: true'))) {
            // this.$ga.enable();
            bootstrap();
        }
    },
    computed: mapState([
        'context',
    ]),
});
/*function getCookie(cname: string): any {
  // Check for cookiebot consent
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '{ statistics: false }';
}*/



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/main.ts